import { ApiSmpGpt } from "@smp/api";
import { Await } from "@smp/utils";
import { useInfiniteQuery, UseInfiniteQueryOptions } from "react-query";

import { useContextApp } from "@/screens/app/context/app";
import { gscSendUserParams } from "@/utils";

const KEY_GPT_PROMPT_LIST = "gpt.prompt.list";

export const useQueryGptPromptList = (
  options?: Omit<
    UseInfiniteQueryOptions<Await<ReturnType<typeof ApiSmpGpt.Prompt.list>>>,
    "queryKey" | "queryFn" | "getNextPageParam"
  >,
) => {
  const {
    state: { organizationId },
  } = useContextApp();

  return useInfiniteQuery<Await<ReturnType<typeof ApiSmpGpt.Prompt.list>>>(
    [KEY_GPT_PROMPT_LIST, { organizationId }],
    ({ pageParam }) => ApiSmpGpt.Prompt.list({ query: pageParam }),
    {
      getNextPageParam: (response) =>
        response.next
          ? Object.fromEntries(new URL(response.next).searchParams)
          : undefined,
      ...(options || {}),
      onSuccess: (...args) => {
        const [data] = args;

        if (data?.pages.length === 1) {
          gscSendUserParams({
            aiassistant: data.pages[0].results.length > 0,
          });
        }

        options?.onSuccess?.(...args);
      },
    },
  );
};

useQueryGptPromptList.KEY = KEY_GPT_PROMPT_LIST;
